import React, { useState, useEffect } from "react";

import { Helmet } from "react-helmet";

const FunnelTemplateEN01 = ({ setPage }) => {
  useEffect(() => {
    setPage("auth");
    currentLanguage(localStorage.getItem("lang") || "EN");
  });
  const [currentLang, currentLanguage] = useState({});

  return (
    <>
      <Helmet>
        <title>Kepicker</title>
      </Helmet>
      <div className="outer__inner auth promo_rr">FUNNEL EN TEMPLATE 01</div>
    </>
  );
};

export default FunnelTemplateEN01;
